import React, { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { LoadingState } from "../common/LoadingState";
import { AppErrorBoundary } from "../common/AppErrorBoundary";
import "../../pages/Dashboard.css";

const SidebarLayout: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const isProwork = location.pathname === "/prowork";
  const collapsed = isProwork || sidebarCollapsed;

  return (
    <div className={`dashboard${isProwork ? " dashboard--prowork" : ""}${collapsed ? " dashboard--sidebar-collapsed" : ""}`}>
      <Sidebar
        isMobileOpen={mobileMenuOpen}
        onMobileToggle={() => setMobileMenuOpen((prev) => !prev)}
        collapsed={collapsed}
        onCollapsedChange={setSidebarCollapsed}
        collapsible={!isProwork}
        showCampaignSwitcher={!isProwork}
      />
      <div className="dashboard-main">
        <AppErrorBoundary>
          <Suspense fallback={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 24px" }}>
              <LoadingState message="Loading..." />
            </div>
          }>
            <Outlet />
          </Suspense>
        </AppErrorBoundary>
      </div>
    </div>
  );
};

export default SidebarLayout;
